import CustomError from '@screens/CustomError';
import { injectLayoutData } from '@utils/layout';
import { GetStaticProps } from 'next';

interface IErrorPageProps {
  statusCode: number;
}

const ErrorPage: React.FC<IErrorPageProps> = ({ statusCode }) => {
  return <CustomError statusCode={statusCode} />;
};

export const getStaticProps = injectLayoutData<any, GetStaticProps>(
  async () => ({
    props: {},
  }),
);
export default ErrorPage;
